import React from 'react'
import { useNavigate } from 'react-router-dom'
import { X, FileQuestion } from 'lucide-react'
import styles from '../../_css/Agency.module.css'

const NotFound = () => {
  const navigate = useNavigate()

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) navigate(-1)
  }

  const overlayStyle = {
    background: 'rgba(19, 27, 45, 0.92)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }
  const modalStyle = {
    maxWidth: 380,
    width: '100%',
    background: 'rgba(15,20,38,0.5)',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 12,
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
    display: 'flex',
    flexDirection: 'column',
  }
  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 24px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  }
  const titleStyle = { fontSize: 20, fontWeight: 700, color: '#f1f5f9', margin: 0 }
  const closeBtnStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    padding: 0,
    border: 'none',
    background: 'rgba(255,255,255,0.06)',
    borderRadius: 8,
    color: '#b0b8c8',
    cursor: 'pointer',
  }
  const bodyStyle = { padding: '24px', textAlign: 'center' }
  const iconWrap = {
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: 'rgba(148, 163, 184, 0.15)',
    color: '#94a3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  }
  const messageStyle = { color: '#b0b8c8', fontSize: 15, margin: 0, lineHeight: 1.5 }
  const footerStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 24px',
    borderTop: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(0,0,0,0.2)',
    borderRadius: '0 0 12px 12px',
  }
  const homeBtnStyle = {
    padding: '10px 20px',
    borderRadius: 10,
    border: 'none',
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(59,130,246,0.25)',
  }

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="notfound-modal-title"
      style={overlayStyle}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={modalStyle}>
        <div style={headerStyle}>
          <h2 id="notfound-modal-title" style={titleStyle}>Not Found</h2>
          <button type="button" onClick={() => navigate(-1)} style={closeBtnStyle} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div style={bodyStyle}>
          <div style={iconWrap}>
            <FileQuestion size={28} />
          </div>
          <p style={messageStyle}>
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div style={footerStyle}>
          <button type="button" onClick={() => navigate('/')} style={homeBtnStyle}>
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound